// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.data-assets-dialog {
  display: flex;
  max-height: 92vh;
  flex-direction: column;
  background: var(--ca-surface, #fff);
}

.dialog-header[mat-dialog-title] {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  padding: 1.5rem 1.5rem 1.1rem;
  margin: 0;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  text-align: left !important;
  white-space: normal;
}

.dialog-title-copy {
  flex: 1 1 auto;
  min-width: 0;
  margin-right: auto;
  text-align: left !important;
}

.dialog-title-copy .eyebrow,
.dialog-title-copy h2,
.dialog-title-copy .dialog-subtitle,
.dialog-title-copy .source-id {
  text-align: left !important;
}

.eyebrow {
  margin: 0 0 0.35rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.dialog-header h2 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.4rem;
  font-weight: 700;
}

.dialog-subtitle {
  margin: 0 0 0.45rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.5;
}

.source-id {
  display: inline-block;
  max-width: 100%;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
  overflow-wrap: anywhere;
}

.dialog-close {
  display: inline-grid;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 2.25rem;
  place-items: center;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: 0.5rem;
  background: #fff;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 1.65rem;
  line-height: 1;
  cursor: pointer;
}

.dialog-close:hover {
  border-color: var(--ca-primary, #0e2e80);
  color: var(--ca-primary, #0e2e80);
}

.dialog-content {
  min-width: 0;
  margin: 0;
  padding: 1.25rem 1.5rem;
  overflow: auto;
}

.asset-list-card {
  min-width: 0;
  padding: 1rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr);
  gap: 0.875rem;
  margin-bottom: 1.1rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.65rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background-color: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
}

.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.8rem;
  flex: 0 0 2.8rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  cursor: pointer;
}

.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.assets-table {
  min-width: 1180px;
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.84rem;
}

.assets-table thead th {
  padding: 0.85rem 0.75rem;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface-subtle, #f7f9fc);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.73rem;
  font-weight: 700;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.assets-table tbody td {
  max-width: 15rem;
  padding: 0.8rem 0.75rem;
  border-bottom-color: var(--ca-border-light, #e9edf3);
  vertical-align: middle;
}

.assets-table tbody tr:last-child td {
  border-bottom: 0;
}

.asset-name-cell {
  min-width: 14rem;
}

.asset-name-cell strong,
.asset-name-cell small {
  display: block;
}

.asset-name-cell strong {
  color: var(--ca-text-primary, #172033);
  font-weight: 650;
}

.asset-name-cell small {
  max-width: 22rem;
  margin-top: 0.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.status-pill,
.classification-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.24rem 0.55rem;
  border: 1px solid #cbe9d5;
  border-radius: 999px;
  background: #eefaf2;
  color: #216e3a;
  font-size: 0.75rem;
  font-weight: 650;
  white-space: nowrap;
}

.status-pill.status-inactive {
  border-color: var(--ca-border, #dfe4ec);
  background: var(--ca-surface-subtle, #f7f9fc);
  color: var(--ca-text-secondary, #4b5870);
}

.classification-pill {
  border-color: #d8e2fb;
  background: #f0f4ff;
  color: var(--ca-primary, #0e2e80);
}

.endpoint-cell,
.identifier-cell {
  min-width: 12rem;
  overflow-wrap: anywhere;
}

.list-footer {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.inline-loading {
  display: flex;
  min-height: 4rem;
  align-items: center;
  gap: 0.65rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.inline-error {
  margin: 0.75rem 0;
  padding: 0.875rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
}

.no-results,
.state-panel {
  display: flex;
  min-height: 11rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}

.state-panel {
  min-height: 16rem;
}

.state-panel > i,
.no-results > i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.75rem;
}

.state-panel.error-state > i {
  color: var(--ca-danger, #dc3545);
}

.state-panel h3,
.no-results p,
.state-panel p {
  margin: 0;
}

.state-panel p,
.no-results p {
  color: var(--ca-text-secondary, #4b5870);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: data-assets-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1.1rem;
  height: 1.1rem;
  border-width: 2px;
}

.dialog-actions {
  margin: 0;
  padding: 0.9rem 1.5rem 1.1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  min-height: 2.6rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.9rem;
  font-weight: 600;
}

.btn-primary {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
}

.btn-primary:hover {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

@keyframes data-assets-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 850px) {
  .dialog-content {
    padding: 1rem;
  }
  .dialog-header {
    padding: 1.1rem 1rem 0.9rem;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .dialog-actions {
    padding: 0.75rem 1rem 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-capture/data-assets-view/data-assets-view.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mCAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EAEA,6BAAA;EACA,SAAA;EAEA,wDAAA;EAEA,2BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AAFF;;AAMA;;;;EAIE,2BAAA;AAHF;;AAMA;EACE,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,2CAAA;EACA,qBAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAHF;;AAMA;EACE,wCAAA;EACA,iCAAA;AAHF;;AAMA;EACE,YAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;AAHF;;AAMA;EACE,YAAA;EACA,aAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAHF;;AAMA;EACE,aAAA;EACA,gEAAA;EACA,aAAA;EACA,qBAAA;AAHF;;AAMA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,0CAAA;EACA,sCAAA;EACA,iBAAA;AAHF;;AAMA;EACE,4CAAA;EACA,gDAAA;EACA,UAAA;AAHF;;AAMA;EACE,0BAAA;EACA,6BAAA;AAHF;;AAMA;EACE,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;AAHF;;AAMA;EACE,2CAAA;AAHF;;AAMA;EACE,YAAA;EACA,gBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,SAAA;EACA,sCAAA;EACA,kBAAA;AAHF;;AAMA;EACE,wBAAA;EACA,kDAAA;EACA,6CAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,uBAAA;EACA,oDAAA;EACA,sBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;;EAEE,cAAA;AAHF;;AAMA;EACE,sCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,iBAAA;EACA,uBAAA;AAHF;;AAMA;;EAEE,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,uCAAA;EACA,6CAAA;EACA,wCAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,iCAAA;AAHF;;AAMA;;EAEE,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,qDAAA;AAHF;;AAMA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;AAHF;;AAMA;;EAEE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;AAHF;;AAMA;EACE,iBAAA;AAHF;;AAMA;;EAEE,uCAAA;EACA,kBAAA;AAHF;;AAMA;EACE,gCAAA;AAHF;;AAMA;;;EAGE,SAAA;AAHF;;AAMA;;EAEE,wCAAA;AAHF;;AAMA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,gDAAA;AAHF;;AAMA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AAHF;;AAMA;EACE,SAAA;EACA,6BAAA;EACA,qDAAA;AAHF;;AAMA;;EAEE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,wCAAA;EACA,sCAAA;AAHF;;AAMA;EACE,6CAAA;EACA,2CAAA;AAHF;;AAMA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AAHF;;AAMA;EACE;IAAK,yBAAA;EAFL;AACF;AAIA;EACE;IACE,aAAA;EAFF;EAKA;IACE,2BAAA;EAHF;EAMA;IACE,qCAAA;EAJF;EAOA;IACE,0BAAA;EALF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.data-assets-dialog {\n  display: flex;\n  max-height: 92vh;\n  flex-direction: column;\n  background: var(--ca-surface, #fff);\n}\n\n.dialog-header[mat-dialog-title] {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n\n  padding: 1.5rem 1.5rem 1.1rem;\n  margin: 0;\n\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\n\n  text-align: left !important;\n  white-space: normal;\n}\n\n.dialog-title-copy {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin-right: auto;\n  text-align: left !important;\n}\n\n\n.dialog-title-copy .eyebrow,\n.dialog-title-copy h2,\n.dialog-title-copy .dialog-subtitle,\n.dialog-title-copy .source-id {\n  text-align: left !important;\n}\n\n.eyebrow {\n  margin: 0 0 0.35rem;\n  color: var(--ca-primary, #0e2e80);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n}\n\n.dialog-header h2 {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n.dialog-subtitle {\n  margin: 0 0 0.45rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n.source-id {\n  display: inline-block;\n  max-width: 100%;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.75rem;\n  overflow-wrap: anywhere;\n}\n\n.dialog-close {\n  display: inline-grid;\n  width: 2.25rem;\n  height: 2.25rem;\n  flex: 0 0 2.25rem;\n  place-items: center;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: 0.5rem;\n  background: #fff;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 1.65rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.dialog-close:hover {\n  border-color: var(--ca-primary, #0e2e80);\n  color: var(--ca-primary, #0e2e80);\n}\n\n.dialog-content {\n  min-width: 0;\n  margin: 0;\n  padding: 1.25rem 1.5rem;\n  overflow: auto;\n}\n\n.asset-list-card {\n  min-width: 0;\n  padding: 1rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr);\n  gap: 0.875rem;\n  margin-bottom: 1.1rem;\n}\n\n.search-field {\n  display: flex;\n  min-width: 0;\n  align-items: stretch;\n}\n\n.search-control {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.65rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background-color: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n}\n\n.search-control:focus {\n  border-color: var(--ca-input-focus, #2850ad);\n  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n  outline: 0;\n}\n\n.search-field .search-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.search-submit {\n  display: inline-grid;\n  width: 2.8rem;\n  flex: 0 0 2.8rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  cursor: pointer;\n}\n\n.search-submit:hover {\n  background: var(--ca-primary-dark, #0d2863);\n}\n\n.table-region {\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.assets-table {\n  min-width: 1180px;\n  margin: 0;\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.84rem;\n}\n\n.assets-table thead th {\n  padding: 0.85rem 0.75rem;\n  border-bottom: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface-subtle, #f7f9fc);\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.73rem;\n  font-weight: 700;\n  letter-spacing: 0.025em;\n  white-space: nowrap;\n}\n\n.assets-table tbody td {\n  max-width: 15rem;\n  padding: 0.8rem 0.75rem;\n  border-bottom-color: var(--ca-border-light, #e9edf3);\n  vertical-align: middle;\n}\n\n.assets-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.asset-name-cell {\n  min-width: 14rem;\n}\n\n.asset-name-cell strong,\n.asset-name-cell small {\n  display: block;\n}\n\n.asset-name-cell strong {\n  color: var(--ca-text-primary, #172033);\n  font-weight: 650;\n}\n\n.asset-name-cell small {\n  max-width: 22rem;\n  margin-top: 0.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n\n.status-pill,\n.classification-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.24rem 0.55rem;\n  border: 1px solid #cbe9d5;\n  border-radius: 999px;\n  background: #eefaf2;\n  color: #216e3a;\n  font-size: 0.75rem;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.status-pill.status-inactive {\n  border-color: var(--ca-border, #dfe4ec);\n  background: var(--ca-surface-subtle, #f7f9fc);\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.classification-pill {\n  border-color: #d8e2fb;\n  background: #f0f4ff;\n  color: var(--ca-primary, #0e2e80);\n}\n\n.endpoint-cell,\n.identifier-cell {\n  min-width: 12rem;\n  overflow-wrap: anywhere;\n}\n\n.list-footer {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.inline-loading {\n  display: flex;\n  min-height: 4rem;\n  align-items: center;\n  gap: 0.65rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.inline-error {\n  margin: 0.75rem 0;\n  padding: 0.875rem 1rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n}\n\n.no-results,\n.state-panel {\n  display: flex;\n  min-height: 11rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 1.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n}\n\n.state-panel {\n  min-height: 16rem;\n}\n\n.state-panel > i,\n.no-results > i {\n  color: var(--ca-primary-light, #2850ad);\n  font-size: 1.75rem;\n}\n\n.state-panel.error-state > i {\n  color: var(--ca-danger, #dc3545);\n}\n\n.state-panel h3,\n.no-results p,\n.state-panel p {\n  margin: 0;\n}\n\n.state-panel p,\n.no-results p {\n  color: var(--ca-text-secondary, #4b5870);\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: data-assets-spin 0.8s linear infinite;\n}\n\n.loading-spinner-sm {\n  width: 1.1rem;\n  height: 1.1rem;\n  border-width: 2px;\n}\n\n.dialog-actions {\n  margin: 0;\n  padding: 0.9rem 1.5rem 1.1rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  min-height: 2.6rem;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.btn-primary {\n  border-color: var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n}\n\n.btn-primary:hover {\n  border-color: var(--ca-primary-dark, #0d2863);\n  background: var(--ca-primary-dark, #0d2863);\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n}\n\n@keyframes data-assets-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 850px) {\n  .dialog-content {\n    padding: 1rem;\n  }\n\n  .dialog-header {\n    padding: 1.1rem 1rem 0.9rem;\n  }\n\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .dialog-actions {\n    padding: 0.75rem 1rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
